import { render, staticRenderFns } from "./userReplyDialog.vue?vue&type=template&id=1954e7e8&scoped=true"
import script from "./userReplyDialog.vue?vue&type=script&lang=js"
export * from "./userReplyDialog.vue?vue&type=script&lang=js"
import style0 from "./userReplyDialog.vue?vue&type=style&index=0&id=1954e7e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1954e7e8",
  null
  
)

export default component.exports